import { ResolveResource } from './utils'
import Factory from './utils/Factory'
const resource = ResolveResource(__filename)
import fetch from '@/fetch'

export default new Factory(resource, {
  addon(payload = {}) {
    let { addon, state, project, reason } = payload

    const params = new URLSearchParams()
    if (reason) params.append('reason', reason)

    return fetch(`/api/project/${project}/addon/${state ? 'enable' : 'disable'}/${addon}?` + params.toString())
  },
  archive(id) {
    return fetch(`/api/project/${id}/archive`, { method: 'POST' })
  },
})
